/**
 * Session Status
 */
export var SessionStatus;

(function (SessionStatus) {
  /** JSDoc */
  SessionStatus["Ok"] = "ok";
  /** JSDoc */

  SessionStatus["Exited"] = "exited";
  /** JSDoc */

  SessionStatus["Crashed"] = "crashed";
  /** JSDoc */

  SessionStatus["Abnormal"] = "abnormal";
})(SessionStatus || (SessionStatus = {}));

export var RequestSessionStatus;

(function (RequestSessionStatus) {
  /** JSDoc */
  RequestSessionStatus["Ok"] = "ok";
  /** JSDoc */

  RequestSessionStatus["Errored"] = "errored";
  /** JSDoc */

  RequestSessionStatus["Crashed"] = "crashed";
})(RequestSessionStatus || (RequestSessionStatus = {}));